export const COLORS = {
  eloBlack: '#4A4A4A',
  eloBlue: '#1E84D7',
  eloGreen: '#39AA75',
  eloGrey20: '#EFEDEF',
  eloOrange: '#FFB000',
  eloRed: '#FF2800',
  eloWhite: '#FFFFFF',
}
